<section id="top" class="hero">
  <div class="hero-photo" [style.background-image]="heroBackgroundImage"></div>
  <div class="hero-veil"></div>

  <div class="hero-content">
    <div class="hero-meta">
      <span ppcEyebrow size="sm" mark>{{ 'hero.eyebrow' | translate }}</span>
      <span ppcEyebrow size="sm">{{ 'hero.meta' | translate }}</span>
    </div>

    <h1 ppcHeading size="lg" class="hero-title">
      @for (line of titleLines(); track $index) {
        <div>{{ line }}</div>
      }
    </h1>

    <div class="hero-lower">
      <p class="hero-sub">{{ 'hero.sub' | translate }}</p>
      <div class="hero-actions">
        <button ppcButton size="lg" type="button" (click)="joinClick.emit()">
          <span>{{ 'hero.cta' | translate }}</span>
          <svg width="16" height="14" viewBox="0 0 16 14" fill="none" aria-hidden="true">
            <path d="M1 7H15M15 7L9 1M15 7L9 13" stroke="currentColor" stroke-width="1.6" />
          </svg>
        </button>
        <div class="hero-actions-note">↳ {{ 'hero.ctaSub' | translate }}</div>
      </div>
    </div>
  </div>

  <div class="hero-stats-wrap">
    <div class="hero-stats">
      @for (stat of stats(); track $index) {
        <div class="hero-stat">
          <app-count-up [raw]="stat.num" [delay]="stat.delay" />
          <div class="hero-stat-label">{{ stat.label }}</div>
        </div>
      }
    </div>
  </div>
</section>
